<template>

   <v-app>

      <ddoNews :news="news"/>

      <div class="animated fadeIn">
         <v-row>
            <v-col>
               <ddoSelectSwitchCustomer ref="mySelect"
                  @switchCustomer="refresh_page"
               >
               </ddoSelectSwitchCustomer>
            </v-col>
         </v-row>

         <h1>{{ $t('nav.dashboard') }}</h1>

         <ddoWaiting :value="loading" color="primary" :message="$t('texts.loading')"/>

         <v-row>
            <v-col sm="6" lg="3">
               <TileSimpleSLA :options="options" :session="session" @loading="refresh_loading" ref="myTile0"/>
            </v-col>
            <v-col v-if="isVisible('SMTPPRO')" sm="6" lg="3">
               <TileSimpleSMTPPRO :options="options" :session="session" @loading="refresh_loading" ref="myTile1"/>
            </v-col>
            <v-col v-if="isVisible('SMS')" sm="6" lg="3">
               <TileSimpleSMSPRO :options="options" :session="session" @loading="refresh_loading" ref="myTile2"/>
            </v-col>
            <v-col v-if="isVisible('BAREOS')" sm="6" lg="3">
               <TileSimpleBACKUPBAREOS :options="options" :session="session" @loading="refresh_loading" ref="myTile3"/>
            </v-col>
            <v-col v-if="isVisible('CERTS')" sm="6" lg="3">
               <TileSimpleCERTIFICATES :options="options" @loading="refresh_loading" ref="myTile4"/>
            </v-col>
         </v-row>
      </div>
   </v-app>
</template>

<script>
import Vue from 'vue';
import i18n from '@/plugins/i18n.js';
import ddoNews from '@/components/ddoNews.vue';
import ddoAlert from '@/components/ddoAlert.vue';
import ddoWaiting from '@/components/ddoWaiting.vue'
import BasicComponent from '@/views/BasicComponent.vue';
import ddoSelectSwitchCustomer from '@/components/ddoSelectSwitchCustomer.vue'
import TileSimple from '@/components/partials/TileSimple.vue';
import TileSimpleSLA from '@/components/partials/TileSimpleSLA.vue';
import TileSimpleBACKUPBAREOS from '@/components/partials/TileSimpleBACKUPBAREOS.vue';
import TileSimpleSMTPPRO from '@/components/partials/TileSimpleSMTPPRO.vue';
import TileSimpleSMSPRO from '@/components/partials/TileSimpleSMSPRO.vue';
import TileSimpleCERTIFICATES from '@/components/partials/TileSimpleCERTIFICATES.vue';

export default {
   name: 'dashboard',
   mixins: [BasicComponent],
   components: {
      ddoNews,
      ddoAlert,
      ddoWaiting,
      ddoSelectSwitchCustomer,
      TileSimple,
      TileSimpleSLA,
      TileSimpleSMTPPRO,
      TileSimpleSMSPRO,
      TileSimpleBACKUPBAREOS,
      TileSimpleCERTIFICATES,
   },
   data: () => {
      return {
         _this: null,
         loading: false,

         news: [],

         options: {},
         session: {},
         resources: [],

         tiles: [
            { name: "TileSimpleSLA    "     , ref: "myTile0", plf_internalcode: "SLA"    , visible: false },
            { name: "TileSimpleSMTPPRO"     , ref: "myTile1", plf_internalcode: "SMTPPRO", visible: false },
            { name: "TileSimpleSMSPRO"      , ref: "myTile2", plf_internalcode: "SMS"    , visible: false },
            { name: "TileSimpleBACKUPBAREOS", ref: "myTile3", plf_internalcode: "BAREOS" , visible: false },
            { name: "TileSimpleCERTIFICATES", ref: "myTile4", plf_internalcode: "CERTS"  , visible: false, ser_code: "CERTIFICATES" },
         ],

      }
   },

   created() {
      this._this = this;
   },

   async mounted() {
      await this.refresh_session();
      await this.refresh_resources();
      await this.refresh_news();
   },

   methods: {

      isVisible(plf_internalcode,ser_code=null) {
         if ( this.resources && Array.isArray(this.resources) ) {
            for ( var i=0;i<this.resources.length;i++) {
               if ( this.resources[i].plf_internalcode==plf_internalcode ) {
                  return true;
               }
            }
         }
         return false;
      },

      async refresh_news() {
         if ( this.session.cus_pk ) {
            let { errorinfos, api_response } = await this.$api.getRows(this.$router,'session'+'/'+this.session.ses_sessionid+'/news');
            if ( api_response && api_response.error==0 && api_response.rows ) {
               this.news = api_response.rows;
            }
         }
      },

      async refresh_session() {
         var { errorinfos, api_response } = await this.$api._get_session(this.$router);
         if ( api_response.error==0 && api_response.row ) {
            this.session = api_response.row;
            for ( var i=0; i<this.$refs.length; i++ ) {
            }
         }
      },

      async refresh_resources() {
         if ( this.session.cus_pk ) {
            let { errorinfos, api_response } = await this.$api.getRows(this.$router,'session'+'/'+this.session.ses_sessionid+'/consumedresources');
            if ( api_response.error==0 && api_response.rows ) {
               this.resources = api_response.rows;
            }
         await this.$refs.myTile0.refresh_data(); // TileSimpleSLA
         }
      },

      async refresh_page() {
         await this.refresh_resources();
         if ( this.tiles && Array.isArray(this.tiles) ) {
            for (var i=0;i<this.tiles.length;i++ ) {
               if ( this.isVisible(this.tiles[i].plf_internalcode) ) {
                  console.log('refresh_page, i='+i+', refresh_data='+this.tiles[i].ref)
                  // No 'await' !
                  this.$refs[this.tiles[i].ref].refresh_data(true);
               }
            }
         }       
      },

   }
}
</script>
